/** Disclosure chevron — right-pointing collapsed, rotates down when expanded.
 *  The ONE disclosure affordance app-wide; size scales it for section heads. */
export function ExpandChevron({ expanded, size = 12 }: { expanded: boolean; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      aria-hidden
      style={{
        flexShrink: 0,
        color: 'currentColor',
        transition: 'transform 120ms ease',
        transform: expanded ? 'rotate(90deg)' : 'rotate(0deg)',
      }}
    >
      <path
        d="M4 2.5 L7.5 6 L4 9.5"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
